export default {
  drawerTitle: '创建优惠券批次',
  businessType: '业务类型',
  businessTypeGeneral: '普通券',
  businessTypeCps: 'Affiliate券',
  contentbatch1: '请选择券模版',
  contentbatch2: '券展示名',
  contentbatch3: '券门槛(购物到达)',
  contentbatch4: '券面额',
  contentbatch5: '使用周期',
  contentbatch6: '领取后有效期',
  contentbatch7: '天',
  contentbatch8: '限制类型 ',
  contentbatch9: '限定品类(商品)',
  contentbatch10: '发行张数',
  contentbatch11: '张(个)',
  contentbatch12: '发放选项',
  contentbatch13: '创建成功后，它将自动展示到领券大厅和店铺首页',
  contentbatch12Option_1: '发布到⼤厅',
  contentbatch12Option_2: '定向⼿动发放',
  contentbatch12OptionCps: 'Affiliate链接发放',
  classId: '输入类目ID集合, 以逗号分隔',
  classId2: '输入ListingID集合,以逗号分隔',
  types1: '全品类(通用)',
  types2: '限品类(品类券)',
  types3: '特定商品',
  moreThan: '大于',
  lessThan: '小于',
  warning1: '此信息不完整',
  warning2: '达到购物额',
  warning3: '达到购物额不能低于',
  warning4: '券面额',
  warning5: '券面额不能高于',
  warning6: '领取后有效期',
  warning7: '领取后有效期要大于0',
  warning8: '发行数',
  warning9: '券面额必须小于购物达到',
  warning10: '请使用英文逗号隔开',
  warning11: '不能以逗号结尾',
  confirmTitle: '创建后不能取消，只能做失效处理，您确定吗',
  warning12: '必须为整数',
  forStore: '对店铺',
  selectCategory: '选择类目'
}
